import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import './styles/style.css';
import { BrowserRouter } from "react-router-dom"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"


const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)

// Registers the Workbox service worker (src/service-worker.js) for offline
// support and faster repeat loads - only takes effect in production builds.
serviceWorkerRegistration.register()
